import React from 'react';
import Text from './Text';
import { useTranslation } from 'react-i18next';
import { DEVICE_TYPES } from '../constants';
import { useAppSelector } from '../app/hooks';
import combineStyles from '../utils/combineStyles';
import TouchableOpacity from './TouchableOpacity';
import getThemeLookup from '../selectors/getThemeLookup';
import { CONTAINER_PROPERTIES, TEXT_PROPERTIES } from '../utils/theme';
import getTermsAndConditionsLink from '../selectors/getTermsAndConditionsLink';
import getPrivacyPolicyLink from '../selectors/getPrivacyPolicyLink';
import getContactUsLink from '../selectors/getContactUsLink';
import getCopyrightText from '../selectors/getCopyrightText';

const Footer = () => {
  const { t } = useTranslation();
  const p = useAppSelector(getThemeLookup);
  const deviceType = useAppSelector(state => state.deviceType);
  const isMobileDevice = deviceType === DEVICE_TYPES.MOBILE;
  const termsAndConditionsLink = useAppSelector(getTermsAndConditionsLink);
  const privacyPolicyLink = useAppSelector(getPrivacyPolicyLink);
  const contactUsLink = useAppSelector(getContactUsLink);
  const copyrightText = useAppSelector(getCopyrightText);

  return (
    <footer style={styles.footerStyle}>
      <div
        style={combineStyles(
          styles.footerContainer,
          isMobileDevice && { flexDirection: 'column', padding: '25px', alignItems: 'left' },
        )}
      >
        <div
          style={combineStyles(
            styles.footerSection,
            isMobileDevice && { flexDirection: 'row' },
            !isMobileDevice && { alignItems: 'center', minWidth: '200px' },
          )}
        >
          {/* <p>Social Icons</p> */}
        </div>
        {/* TODO: add paddingTop: '50px', paddingBottom: '50px' if we have social icons and installation links */}
        <div
          style={combineStyles(
            styles.footerSection,
            isMobileDevice && { flexDirection: 'column', gap: 30 },
            !isMobileDevice && { alignItems: 'center', gap: '30px' },
          )}
        >
          {privacyPolicyLink && (
            <TouchableOpacity
              ariaLabel="footerLink"
              style={combineStyles(
                styles.footerLink,
                p('footerLinkContainer', CONTAINER_PROPERTIES),
              )}
              onClick={() => privacyPolicyLink && window.open(privacyPolicyLink, '_blank')}
            >
              <Text
                lines={1}
                style={combineStyles(styles.footerLink, p('footerLinkText', TEXT_PROPERTIES))}
              >
                {t('footer.privacyPolicy')}
              </Text>
            </TouchableOpacity>
          )}
          {termsAndConditionsLink && (
            <TouchableOpacity
              ariaLabel="footerLink"
              style={combineStyles(
                styles.footerLink,
                p('footerLinkContainer', CONTAINER_PROPERTIES),
              )}
              onClick={() =>
                termsAndConditionsLink && window.open(termsAndConditionsLink, '_blank')
              }
            >
              <Text
                lines={1}
                style={combineStyles(styles.footerLink, p('footerLinkText', TEXT_PROPERTIES))}
              >
                {t('footer.termsAndConditions')}
              </Text>
            </TouchableOpacity>
          )}
          {contactUsLink && (
            <TouchableOpacity
              ariaLabel="footerLink"
              style={combineStyles(
                styles.footerLink,
                p('footerLinkContainer', CONTAINER_PROPERTIES),
              )}
              onClick={() => contactUsLink && window.open(contactUsLink, '_blank')}
            >
              <Text
                lines={1}
                style={combineStyles(styles.footerLink, p('footerLinkText', TEXT_PROPERTIES))}
              >
                {t('footer.contactUs')}
              </Text>
            </TouchableOpacity>
          )}
          {copyrightText && (
            <TouchableOpacity
              ariaLabel="footerLink"
              style={combineStyles(
                styles.footerLink,
                p('footerLinkContainer', CONTAINER_PROPERTIES),
              )}
              onClick={() => {}}
            >
              <Text
                lines={1}
                style={combineStyles(styles.footerLink, p('footerLinkText', TEXT_PROPERTIES))}
              >
                {copyrightText || t('footer.copyright', { year: new Date().getFullYear() })}
              </Text>
            </TouchableOpacity>
          )}
        </div>
        <div
          style={combineStyles(
            styles.footerSection,
            isMobileDevice && { flexDirection: 'row' },
            !isMobileDevice && { alignItems: 'center', minWidth: '200px' },
          )}
        >
          {/* <p>App store installation links</p> */}
        </div>
      </div>
    </footer>
  );
};

const styles: Styles = {
  footerStyle: {
    borderTop: '1px solid #DFDFDF',
  },
  footerContainer: {
    display: 'flex',
    padding: '42px 20px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  footerSection: {
    display: 'flex',
    gap: '10px',
  },
  footerLink: {},
};

export default Footer;
